<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
// import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Supplier Purchase Profile",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Supplier Purchase Profile",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Supplier Purchase Profile",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "actions",
          sortable: false,
          label: "ACTION",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: "",
        },
        {
          key: "tt_amt",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "amt_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount_field",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "supplier",
          sortable: true,
          label: "SUPPLIER",
        },
        {
          key: "invoice",
          sortable: true,
          label: "INVOICE NO",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "RECORDED BY",
        },
        // {
        //   key: "actions",
        //   sortable: false,
        //   label: "ACTION",
        // },
      ],
      amountError: "",
      modeError: "",

      filterPurchases: {
        product: '',
        invoiceno: '',
        supplier: atob(this.$route.params.id),
        title: 'Supplier Purchase Profile'
      },

      totals:{
        totalAmount:0,
        totalPaid:0,
        totalDiscount:0,
        totalBalance:0,
      }, 

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("purchase", ["SaveStatus","SupplierPurchases"]),
    ...mapGetters("auth",["MyUserPerm","business","branch","Branches","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    ...mapGetters("products", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.SupplierPurchases ? this.SupplierPurchases.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.SupplierPurchases ? this.SupplierPurchases.length : 1;
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    SupplierPurchases(newValue){
      if(newValue){
        this.SupplierPurchases();
      }
    }
  },
  methods: {
    ...mapActions({
      FetchSupplierPurchases: "purchase/fetchSupplierPurchases",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchProducts: "products/fetchProducts",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    Receipt_print(Id){
      window.open(
        `https://${window.location.host}/receipts/purchasesreceipt.php?id=${btoa(Id)}`
      );
    },

    filterReport(){
      this.FetchSupplierPurchases(this.filterPurchases);
    },
    
    SetSupplierPurchaseTotal(){
      if(this.SupplierPurchases){
      let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      this.SupplierPurchases.forEach((item)=>{
        total_amount = total_amount+parseInt(item.totAmt);
        total_paid = total_paid+parseInt(item.amtPaid);
        total_discount = total_discount+parseInt(item.discount);

        this.totals.totalBalance = this.totals.totalAmount-(this.totals.totalPaid+this.totals.totalDiscount);
      });
      this.totals.totalPaid = total_paid;
      this.totals.totalAmount = total_amount;
      this.totals.totalDiscount = total_discount;  
      this.totals.totalBalance = total_amount-(total_paid+total_discount)
      }
    },
  },
  created() {
    this.FetchSupplierPurchases(this.filterPurchases);
    this.FetchGeneralSettings();
    this.FetchProducts();
    this.SetSupplierPurchaseTotal();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4 text-uppercase">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">SUPPLIER PURCHASE PROFILE FOR {{ SupplierPurchases?SupplierPurchases[0].supplier:'' }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>PRODUCT</label>
                
                <model-list-select
                  :list="Products ? Products : []"
                  v-model="filterPurchases.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-4 form-group">
                <label>INVOICE NO.</label>
                
                <input
                  class="form-control"
                  v-model="filterPurchases.invoiceno"
                  placeholder="Enter Invoice No"
                  @keyup.enter="filterReport()"
                />
              </div>
              <div class="col-md-4 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="SupplierPurchases?SupplierPurchases:[]"
                  :fields="GeneralSettings.capture_purchase_invoiceno == 1?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(tt_amt)="data">
                  {{ thousandSeperator(data.item.totAmt) }}
                </template>
                <template #cell(amt_paid)="data">
                    {{ thousandSeperator(data.item.amtPaid) }}
                </template>
                <template #cell(discount_field)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(details)="data">
                  <table  class="table">
                    <thead>
                      <th>PRODUCT</th>
                      <th>QTY</th>
                      <th>PRICE</th>
                    </thead>
                    <tbody>
                    <tr v-for="(det,d) in data.item.items" :key="d" width="100%">
                      <td>{{ det.product }}</td>
                      <td>{{ det.qty }}{{ det.usymbol }}</td>
                      <td>{{ det.unitPrice?thousandSeperator(det.unitPrice):0 }}</td>
                      <td>{{ det.batch }}</td>
                      <td>{{ det.expiry }}</td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              </b-table>

              <div class="row">
                  <div class="col-md-3">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeperator(totals.totalAmount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Paid: <span class="text-danger">{{thousandSeperator(totals.totalPaid)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{thousandSeperator(totals.totalDiscount)}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Balance: <span class="text-danger">{{thousandSeperator(totals.totalBalance)}}</span></h5>
                  </div>
              </div>
            </div>
            <Loader  v-if="!SupplierPurchases"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
